import { styled } from '@mui/system'

const Wrapper = styled('footer')`
	padding-bottom: var(--footerActionBarHeight);
`

export { Wrapper }
